// in src/index.js
const { render } = wp.element;
import TvBlog from "./tv-blog";
import OriginalBlog from "./original-blog";

/* global wp, multisite */

const Blog = () => {

	if (multisite.site_id == "1"){
		return (<TvBlog/>);
	} else if (multisite.site_id == "2"){
		return (<OriginalBlog/>);
	}
	return (
		<div>
		</div>
	);
};

export default Blog;


render(
	<Blog />,
	document.getElementById("app")
);